function fieldsMaterialDesignInit() {
    inputMaterialDesignInit();
    selectMaterialDesignInit();
}



// Sunrise 2.0 - Input - Material Design

function inputMaterialDesignInit() {
    var inputs = document.querySelectorAll('.s20-form-input--md .s20-form-input__field');
    for(var i = 0; i < inputs.length; i++) {
        var element = inputs[i];

        if(element.value) {
            element.closest('.s20-form-input--md').classList.add('s20-form-input--md-active');
        }

        element.addEventListener('focus', function(event) {
            this.closest('.s20-form-input--md').classList.add('s20-form-input--md-active');
        });

        element.addEventListener('blur', function(event) {
            if(!this.value) {
                this.closest('.s20-form-input--md').classList.remove('s20-form-input--md-active');
            }
        });
    }
}



// Sunrise 2.0 - Select - Material Design

function selectMaterialDesignInit() {
    var selects = document.querySelectorAll('.s20-form-select--md .s20-form-select__field');
    for(var i = 0; i < selects.length; i++) {
        var element = selects[i];

        if(element.value) {
            element.closest('.s20-form-select--md').classList.add('s20-form-select--md-active');
        }

        element.addEventListener('change', function(event) {
            if(this.value) {
                this.closest('.s20-form-select--md').classList.add('s20-form-select--md-active');
            } else {
                this.closest('.s20-form-select--md').classList.remove('s20-form-select--md-active');
            }
        });
    }
}



document.addEventListener('DOMContentLoaded', function() {
    fieldsMaterialDesignInit();
});

var target = document.body;
var config = { subtree: true, childList: true };

var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if(mutation.addedNodes.length) {
            fieldsMaterialDesignInit();
        }
    });
});

observer.observe(target, config);
